<template>
  <div class="preorder-tips">
    <ul class="help-content">
      <li class="head">
        <div class="tips_icon"><icon>quanju-buzhichituikuan</icon></div>
        <div class="tips_header">注意事项</div>
      </li>
      <li v-if="isInUnionPayApp" class="newTips">
        <div class="stars">*</div>
        <div class="boxx" style="font-size: 15px;">
          “惠观影”优惠金额将在提交订单后“付款详情”页面展示，支付时即完成抵扣。
        </div>
      </li>
      <li>
        <div class="stars">*</div>
        <div class="boxx">
          即日起购票成功后，订座信息不再发送短信，改为公众号通知或App站内通知
        </div>
      </li>
      <li>
        <div class="stars">*</div>
        <div class="boxx">该影城不支持订座票退换，请您确认后再进行购买</div>
      </li>
      <li>
        <div class="stars">*</div>
        <div class="boxx">请确定号码无误，支付成功后将无法修改</div>
      </li>
      <li v-if="isMzVip">
        <div class="stars">*</div>
        <div class="boxx">
          票面打印价由影院统一设置，可能存在票面价格与订购价格不符的情况
        </div>
      </li>
      <li>
        <div class="stars">*</div>
        <div class="boxx">更多信息请查看影院详情</div>
      </li>
    </ul>
  </div>
</template>

<script>
import op from "object-path";
import icon from "./icon.vue";
import cookie from "../lib/cookie.js";
import CONSTANT from "../constant/cookie.js";
import { app } from "../util/platform";
export default {
  name: "preorder-tips",
  data() {
    return {
      isMzVip: cookie(CONSTANT.COOKIE_CO) == CONSTANT.COOKIE_CO_IS_SDYXVIP
    };
  },
  components: {
    icon
  },
  computed: {
    isInUnionPayApp() {
      //判断是否在云闪付APP中打开
      if (app.isUnionPay()) {
        return true;
      }
      return false;
    }
  },
  mounted() {}
};
</script>

<style lang="less" scoped>
@import "../../stylesheet/variable.less";
.preorder-tips {
  border-radius: 8px;
  background-color: @white;
  width: 93%;
  margin: 16px auto;
  .help-content {
    margin: 0;
    font-size: 14px;
    line-height: 25px;
    padding: 12px 15px;
    list-style: none;
    color: rgb(160, 107, 67);
    li {
      display: flex;
    }
    .head {
      font-size: 15px;

      .tips_header {
      }
      .tips_icon i {
        font-size: 20px;
      }
    }
    .boxx {
    }
    .stars {
      padding-right: 5px;
    }
    .newTips {
      color: #c03131;
    }
  }
}
</style>
